import { render, staticRenderFns } from "./MetadataConflictDetail.vue?vue&type=template&id=ebd061dc&scoped=true&"
import script from "./MetadataConflictDetail.vue?vue&type=script&lang=js&"
export * from "./MetadataConflictDetail.vue?vue&type=script&lang=js&"
import style0 from "./MetadataConflictDetail.vue?vue&type=style&index=0&id=ebd061dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd061dc",
  null
  
)

export default component.exports